import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useRoom } from '../hooks/useRoom';
import { PageHeader } from '../components/RoomList/PageHeader';
import { RoomTable } from '../components/RoomList/RoomTable';
import { ErrorSnackbar } from '../components/RoomList/ErrorSnackbar';

export default function RoomListPage() {
  const navigate = useNavigate();
  const { rooms, isLoading, error, setError } = useRoom();

  const handleView = (room: any) => {
    navigate(`/rooms/${room.id}`);
  };

  const handleCreate = () => {
    navigate('/rooms/new');
  };

  const handleCloseError = () => setError(null);

  return (
    <Box style={{
      background: '#fff',
      borderRadius: 16,
      padding: 32,
      boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)',
      maxWidth: '100%',
      margin: '0 auto'
    }}>
      <ErrorSnackbar error={error} onClose={handleCloseError} />
      <PageHeader loading={isLoading} onCreate={handleCreate} />
      <RoomTable rows={rooms} loading={isLoading} onView={handleView} />
    </Box>
  );
}